import { render, staticRenderFns } from "./assistance-add-to-cart.component.vue?vue&type=template&id=26c1971a&"
import script from "./assistance-add-to-cart.component.vue?vue&type=script&lang=ts&"
export * from "./assistance-add-to-cart.component.vue?vue&type=script&lang=ts&"
import style0 from "./assistance-add-to-cart.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assistance-add-to-cart.component.vue"
export default component.exports